var _defs, _rect, _rect2, _rect3, _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermisDeConduire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_3",
    "data-name": "Calque 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 763 1112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e35376;}.cls-2{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Permis de conduire") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 763,
    height: 1112
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 28,
    y: 35.63,
    width: 709,
    height: 1041.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 122,
    y: 556,
    width: 520,
    height: 447
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M927.55,551.27h127.61v40.07H967.48v38h83.72V667.4H967.48v84.1H927.55Z",
    transform: "translate(-610.5 -383.5)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 381.5,
    cy: 267.5,
    rx: 269.97,
    ry: 182
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermisDeConduire);
export default __webpack_public_path__ + "static/media/permis_de_conduire.eeb7326c55de56e4a1c5793e2db2b7d3.svg";
export { ForwardRef as ReactComponent };